import React from "react";

import { useI18n } from "../i18n/I18nContext";

export default function DashboardKpiCard({ label, value, sub, color }) {
  const { t, ui } = useI18n();

  return (
    <div style={{ ...S.kpiCard, borderTopColor: color }}>
      <div style={{ ...S.kpiValue, color }}>{value}</div>
      <div style={S.kpiLabel}>{label}</div>
      <div style={S.kpiSub}>{sub}</div>
    </div>
  );
}

export function DashboardKpiRow({ children }) {
  return <div style={S.kpiRow}>{children}</div>;
}

const S = {
  kpiRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: 14,
    marginBottom: 4,
  },
  kpiCard: {
    background: "rgba(255,255,255,0.03)",
    border: "1px solid #1e3a50",
    borderRadius: 14,
    padding: "16px 18px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
    borderTopWidth: 3,
    backdropFilter: "blur(8px)",
  },
  kpiValue: {
    fontSize: 28,
    fontWeight: 900,
    lineHeight: 1.1,
    textAlign: "center",
  },
  kpiLabel: {
    fontSize: 10,
    color: "#94a3b8",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    textAlign: "center",
  },
  kpiSub: {
    fontSize: 10,
    color: "#64748b",
    textAlign: "center",
  },
};
